import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { DraftsI, ObjectsI, ProjectsI, SubmittalsDTO } from '../_models/projects';
@Injectable({
  providedIn: 'root'
})
export class ProjectsService {

  constructor(private http: HttpClient) { }
  getProjects(): Observable<ProjectsI[]> {
    return this.http.get<ProjectsI[]>(environment.apiUrl + `/projects`);
  }
  purchaseOrders(projectId: number): Observable<ObjectsI[]> {
    return this.http.get<ObjectsI[]>(environment.apiUrl + `/projects/${projectId}/objects`);
  }
  draftUploads(projectId: number, objectId: number): Observable<DraftsI[]> {
    return this.http.get<DraftsI[]>(environment.apiUrl + `/projects/${projectId}/objects/${objectId}/uploads`);
  }

  getSubmittalsData(projectId: number, includeFiles: boolean = false): Observable<SubmittalsDTO> {
    return this.http.get<SubmittalsDTO>(environment.apiUrl + `/projects/${projectId}/submittals?includeFiles=${includeFiles}`);
  }

  exportSubmittalsWithFilters(projectId: number, status: string, objectId: number | null): Observable<HttpResponse<Blob>> {
    let params = new HttpParams();
    if (status) {
      params = params.set('status', status);
    }
    if (objectId) {
      params = params.set('objectId', objectId);
    }
    return this.http.get(environment.apiUrl + `/projects/${projectId}/submittals/export`, { params, responseType: 'blob', observe: 'response' });
  }

}

